var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"max-width":"400","bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({directives:[{name:"show",rawName:"v-show",value:(!!_vm.note),expression:"!!note"}],class:_vm.contentClass,attrs:{"size":_vm.size,"color":"amber"}},on),[_vm._v(" mdi-note-text ")])]}}])},[_c('span',{domProps:{"textContent":_vm._s(_vm.note)}})])}
var staticRenderFns = []

export { render, staticRenderFns }